module.exports = __webpack_public_path__ + "img/doflogo.afb72e55.png";